/**
 * @Author: zachalam
 * @Date:   2017-04-12T10:38:53-07:00
 * @Email:  zach@reflexmedia.com
 * @Last modified by:   zachalam
 * @Last modified time: 2017-04-12T10:38:53-07:00
 */

import { legacy_createStore as createStore, applyMiddleware } from 'redux';

import { loadState, saveState } from './localStorage';
import throttle from 'lodash/throttle';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import rootReducer from './reducers/index';
import { useDispatch } from 'react-redux';

const existingState = loadState();

const middleware = [thunk];

// remove logging in production
if (process.env.REACT_APP_ENV !== 'production') {
  // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
  middleware.push(createLogger());
}

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const store = createStore(rootReducer, existingState, applyMiddleware(...middleware));

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();

// persist reducer state to ls at most every 2 seconds (on reducer change).
store.subscribe(
  throttle(() => {
    saveState({
      auth: store.getState().auth,
      profile: store.getState().profile,
      search: store.getState().search,
      meta: store.getState().meta,
      settings: store.getState().settings,
    });
  }, 2000)
);

export default store;
